module.exports = __webpack_public_path__ + "media/images/home/celebrity-rachael-ray-a73531de93bbe13e617fd9c5626904c2.jpg";